import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Programs', path: '/programs' },
  { label: 'Trainers', path: '/trainers' },
  { label: 'About', path: '/about' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Contact', path: '/contact' },
];

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-boxing-black/95 backdrop-blur-md shadow-lg shadow-black/30'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-5 md:px-8 lg:px-12 h-18 md:h-20">
        <Link to="/" className="flex items-center gap-3 shrink-0">
          <img
            src="https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/7c39edfd8d694e22a7ddecad8773ce48.png"
            alt="Moin Khan Boxing Academy"
            className="h-10 w-10 md:h-12 md:w-12 object-contain"
          />
          <div className="hidden sm:block">
            <span className="font-bebas text-lg md:text-xl tracking-wider text-white leading-none">
              MOIN KHAN
            </span>
            <span className="block font-oswald text-[10px] md:text-xs uppercase tracking-[3px] text-white/60 leading-none mt-0.5">
              Boxing Academy
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`relative font-oswald uppercase text-sm tracking-[2px] transition-colors duration-300 ${
                isActive(link.path)
                  ? 'text-white'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-[2px] bg-boxing-red transition-all duration-300 ${
                  isActive(link.path) ? 'w-full' : 'w-0 hover:w-full'
                }`}
              />
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </span>
            Join Now
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="Toggle menu"
        >
          <span className="w-6 h-6 flex items-center justify-center">
            {mobileOpen ? (
              <i className="ri-close-line text-2xl" />
            ) : (
              <i className="ri-menu-3-line text-2xl" />
            )}
          </span>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-boxing-black/98 backdrop-blur-lg border-t border-white/10">
          <div className="flex flex-col px-5 py-6 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-oswald uppercase text-sm tracking-[2px] py-2 ${
                  isActive(link.path)
                    ? 'text-white'
                    : 'text-white/70'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base" />
              </span>
              Join Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}